/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LootBoxCycleType = {
    NONE: 'NONE',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    ON_DEPLETION: 'ON_DEPLETION'
} as const;
export type LootBoxCycleType = typeof LootBoxCycleType[keyof typeof LootBoxCycleType];


export function instanceOfLootBoxCycleType(value: any): boolean {
    for (const key in LootBoxCycleType) {
        if (Object.prototype.hasOwnProperty.call(LootBoxCycleType, key)) {
            if (LootBoxCycleType[key as keyof typeof LootBoxCycleType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LootBoxCycleTypeFromJSON(json: any): LootBoxCycleType {
    return LootBoxCycleTypeFromJSONTyped(json, false);
}

export function LootBoxCycleTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LootBoxCycleType {
    return json as LootBoxCycleType;
}

export function LootBoxCycleTypeToJSON(value?: LootBoxCycleType | null): any {
    return value as any;
}

export function LootBoxCycleTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): LootBoxCycleType {
    return value as LootBoxCycleType;
}

